var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
/* eslint-disable tailwindcss/no-arbitrary-value */
import React, { useEffect } from 'react';
import { Button } from '@one-thd/sui-atomic-components';
import { DisconnectBuildertrendAccount } from '../../../../hooks/purchase-history-hooks';
import { builderTrendHostName } from '../../../../utils/buildertrend-utils';
import { getWindow } from '../../../../utils/general';
import '../../../../styles/buildertrend.scss';
// Connect Click
var handleConnectClick = function () {
    var _a, _b;
    var getHostName = ((_a = getWindow()) === null || _a === void 0 ? void 0 : _a.location.hostname) || '';
    var encodedRedirectURI = encodeURIComponent("https://".concat(getHostName, "/myaccount/purchase-history"));
    (_b = getWindow()) === null || _b === void 0 ? void 0 : _b.location.assign("https://".concat(builderTrendHostName(), "?oauthRedirectType=thd&redirect_uri=").concat(encodedRedirectURI, "&state=STATE"));
};
var renderConnectDisconnectButton = function (btApiState, setBtApiState, userIsLinked, btnTextLogic, adminUnlinkRadio) {
    if (!(btApiState === null || btApiState === void 0 ? void 0 : btApiState.btResponse)) {
        return (React.createElement("button", { className: "sui-bg-[#004FD6] sui-text-[#cccccc] hover:sui-text-inverse sui-font-semibold sui-py-2 sui-px-4 sui-border sui-border-strongest hover:sui-border-transparent sui-rounded sui-w-40 disabled:sui-cursor-wait ", type: "button", disabled: btApiState.isLoading, onClick: function () {
                if (userIsLinked) {
                    DisconnectBuildertrendAccount(adminUnlinkRadio, btApiState, setBtApiState);
                }
                else {
                    handleConnectClick();
                }
            } }, btApiState.isLoading ? (React.createElement("svg", { className: "sui-animate-spin sui-inline-flex", width: "20", height: "20", viewBox: "0 0 24 24", "data-testid": "LoadingIcon" },
            React.createElement("path", { d: "M0 12a12 12 0 1024 0 12 12 0 10-24 0M4 12a8 8 0 1016 0 8 8 0 10-16 0", className: "sui-opacity-25", fill: "currentColor", fillRule: "evenodd" }),
            React.createElement("path", { className: "sui-opacity-75", fill: "currentColor", d: "M 4 12 a 8 8 0 0 1 8 -8 V 0 C 5.373 0 0 5.373 0 12 h 4 z m 2 5.291 A 7.962 7.962 0 0 1 4 12 H 0 c 0 3.042 1.135 5.824 3 7.938 l 3 -2.647" }))) : (btnTextLogic)));
    }
    return undefined;
};
/**
 * Buildertrend Footer element and components
 */
export var BuildertrendModalFooter = function (_a) {
    var handleClose = _a.handleClose, userIsLinked = _a.userIsLinked, btApiState = _a.btApiState, setBtApiState = _a.setBtApiState, adminUnlinkRadio = _a.adminUnlinkRadio;
    var btnTextLogic = userIsLinked ? 'Disconnect' : 'Connect';
    useEffect(function () {
        return function () {
            setBtApiState(__assign(__assign({}, btApiState), { btResponse: undefined }));
        };
    }, []);
    /**
     * Button style for close btn, currently uses Ghost variant until told otherwise.
     *  */
    return (React.createElement("div", { className: "sui-flex sui-justify-end sui-w-full sui-pt-6" },
        React.createElement("div", { className: "sui-w-28" },
            React.createElement(Button, { variant: "ghost", onClick: function () {
                    handleClose();
                } }, "Close")),
        renderConnectDisconnectButton(btApiState, setBtApiState, userIsLinked, btnTextLogic, adminUnlinkRadio)));
};
